import { z } from "zod";

export type RoleDto = {
    role: string;
}

export type UserDto = {
    id: number;
    nom: string;
    prenom: string;
    email: string;
    enabled: boolean;
    locked: boolean
    mobile: string;
    username: string;
    password: string;
    roles: RoleDto[];
}

export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_ENSEIGNANT = "ROLE_ENSEIGNANT";
export const ROLE_TRESORIER = "ROLE_TRESORIER";
export const ROLE_UTILISATEUR = "ROLE_UTILISATEUR";

const ROLES_CHATBOT = [ROLE_ADMIN, ROLE_ENSEIGNANT, ROLE_TRESORIER];

/**
 * L'assistant s'appuie sur une documentation qui ne couvre que les activités internes
 * (gestion, enseignement, trésorerie) : il reste donc fermé aux simples utilisateurs
 * et au public. Règle partagée par toutes les surfaces qui exposent l'assistant.
 */
export const canUseChatbot = (roles: string[] | undefined | null): boolean =>
    (roles ?? []).some((role) => ROLES_CHATBOT.includes(role));

export const AccountInfosSchema = z.object({
    username: z.string(),
    prenom: z.optional(z.string()),
    enabled: z.boolean(),
});
export type AccountInfos = z.infer<typeof AccountInfosSchema>;
